import { render } from "./index.vue?vue&type=template&id=59a0cee7&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=59a0cee7&lang=scss&scoped=true"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59a0cee7"],['__file',"src/views/food/restaurant/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "59a0cee7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('59a0cee7', __exports__)) {
    console.log('reload')
    api.reload('59a0cee7', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=59a0cee7&scoped=true", () => {
    console.log('re-render')
    api.rerender('59a0cee7', render)
  })

}


export default __exports__